"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _WizardControlStep = require("./WizardControlStep");
var _FirstStep = require("./FirstStep");
var _SecondStep = require("./SecondStep");
var _ThirdStep = require("./ThirdStep");
var _FourthStep = require("./FourthStep");
var _ui = require("../../../../../../ui");
var _utils = require("../../../../../../../utils");
var _reactResponsive = require("react-responsive");
var _excluded = ["isOpen", "toggle", "onSubmit", "setPrevStep", "setNextStep", "totpKeyLoading", "totpKey", "totpQrUrl", "submitLoading"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WizardControl = (0, _styledComponents.default)(_ui.WizardControl)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 32px 40px 48px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 24px 40px 32px;\n  "]))));
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-height: 588px;\n  padding: 0 60px 40px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 0 10px 40px;\n    min-height: 574px;\n  "]))));
var Component = function Component(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle,
    onSubmit = _ref.onSubmit,
    setPrevStep = _ref.setPrevStep,
    setNextStep = _ref.setNextStep,
    totpKeyLoading = _ref.totpKeyLoading,
    totpKey = _ref.totpKey,
    totpQrUrl = _ref.totpQrUrl,
    submitLoading = _ref.submitLoading,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  var Title = isMobile ? _ui.H5 : _ui.H4;
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: isOpen,
    toggle: toggle
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    className: "pb-2",
    onClick: toggle
  }), /*#__PURE__*/_react.default.createElement(ModalBody, {
    className: "d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(_ui.Wizard, props, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Title, {
    className: "text-center"
  }, t('setUpAuthenticator')), /*#__PURE__*/_react.default.createElement(WizardControl, {
    barColor: "tertiary",
    className: "w-100",
    steps: 4,
    stepComponent: _WizardControlStep.WizardControlStep
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    className: "d-flex flex-grow-1",
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_FirstStep.FirstStep, {
    onPrevStepClick: toggle,
    onNextStepClick: setNextStep
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    className: "d-flex flex-grow-1",
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_SecondStep.SecondStep, {
    onNextStepClick: setNextStep,
    onPrevStepClick: setPrevStep,
    loading: totpKeyLoading,
    totpKey: totpKey,
    totpQrUrl: totpQrUrl
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    className: "d-flex flex-grow-1",
    order: 2
  }, /*#__PURE__*/_react.default.createElement(_ThirdStep.ThirdStep, {
    onNextStepClick: setNextStep,
    onPrevStepClick: setPrevStep,
    totpKey: totpKey
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    className: "d-flex flex-grow-1",
    order: 3
  }, /*#__PURE__*/_react.default.createElement(_FourthStep.FourthStep, {
    submitLoading: submitLoading,
    onPrevStepClick: setPrevStep,
    onSubmit: onSubmit
  })))));
};
exports.Component = Component;